import { render, staticRenderFns } from "./confirmTab.vue?vue&type=template&id=2b6d42c6&scoped=true&"
import script from "./confirmTab.vue?vue&type=script&lang=js&"
export * from "./confirmTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d42c6",
  null
  
)

export default component.exports